<div class="flex flex-middle bg-col-51 p-t-3 p-b-3 p-r-3 b-radius-4">
    <button class="p-l-3 p-r-3 flex flex-middle"
            [iconButton]
            [status]="status"
            cy-searchbutton
            #iconOn
            (click)="goToSearchView()"
            aria-label="Search"
            [icon]="'search'"></button>
    <input type="text"
           cy-searchInput
           [(ngModel)]="term"
           (keyup)="onInputKeyUp($event)"
           (focus)="onInputFocus()"
           #input
           class="flex-grow _search-input"
           [placeholder]="'Search for a product' | translate">
</div>
